"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.string.ends-with");
require("core-js/modules/es6.string.starts-with");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _topicManagement = require("@/api/community/topicManagement");
var _memberManagement = require("@/api/member/memberManagement");
var _index = require("@/utils/index.js");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'TopicManagement',
  data: function data() {
    return {
      searchForm: {
        id: '',
        title: ''
      },
      tableData: [],
      tableLoading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      dialogTitle: '',
      isEdit: false,
      editForm: {
        id: '',
        title: '',
        num: 0,
        peopleNum: 0,
        ordno: 0,
        isTj: 0,
        isHot: 0
      },
      editRules: {
        title: [{
          required: true,
          message: '请输入主题',
          trigger: 'blur'
        }],
        num: [{
          required: true,
          message: '请输入贴数',
          trigger: 'blur'
        }],
        peopleNum: [{
          required: true,
          message: '请输入人数',
          trigger: 'blur'
        }],
        ordno: [{
          required: true,
          message: '请输入序号',
          trigger: 'blur'
        }]
      },
      imagePrefix: '' // 添加图片前缀字段
    };
  },
  mounted: function mounted() {
    this.getImagePrefix(); // 获取图片前缀
    this.fetchData();
  },
  methods: {
    // 获取图片前缀
    getImagePrefix: function () {
      var _getImagePrefix2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 1;
              return (0, _memberManagement.getImagePrefix)();
            case 1:
              response = _context.sent;
              if (response.code === 200 && response.data) {
                this.imagePrefix = response.data;
              }
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              console.error('获取图片前缀失败:', _t);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 2]]);
      }));
      function getImagePrefix() {
        return _getImagePrefix2.apply(this, arguments);
      }
      return getImagePrefix;
    }(),
    // 获取完整图片URL
    getImageUrl: function getImageUrl(url) {
      // 如果没有url则返回空
      if (!url) return '';

      // 如果已经是完整URL则直接返回
      if (url.startsWith('http')) {
        return url;
      }

      // 如果有图片前缀，使用图片前缀
      if (this.imagePrefix) {
        // 确保前缀末尾没有斜杠，url开头有斜杠
        var prefix = this.imagePrefix.endsWith('/') ? this.imagePrefix.slice(0, -1) : this.imagePrefix;
        var path = url.startsWith('/') ? url : '/' + url;
        return prefix + path;
      }

      // 如果是相对路径，则加上基础URL
      return process.env.VUE_APP_BASE_API + url;
    },
    handleAdd: function handleAdd() {
      this.isEdit = false;
      this.dialogTitle = '新增话题';
      this.editForm = {
        id: '',
        title: '',
        num: 0,
        peopleNum: 0,
        ordno: 0,
        isTj: 0,
        isHot: 0
      };
      this.dialogVisible = true;
    },
    handleSearch: function handleSearch() {
      this.currentPage = 1;
      this.fetchData();
    },
    handleReset: function handleReset() {
      this.searchForm = {
        id: '',
        title: ''
      };
      this.currentPage = 1;
      this.fetchData();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.fetchData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchData();
    },
    handleDelete: function handleDelete(row) {
      var _this = this;
      this.$confirm('此操作将永久删除该话题, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _topicManagement.deleteTopic)(row.id).then(function (response) {
          _this.$message.success('删除成功');
          _this.fetchData();
        }).catch(function (error) {
          _this.$message.error('删除失败');
        });
      }).catch(function () {
        _this.$message.info('已取消删除');
      });
    },
    updateSequence: function updateSequence(row) {
      var _this2 = this;
      // 更新序号
      var formData = {
        id: row.id,
        ordno: row.ordno
      };
      (0, _topicManagement.updateTopic)(formData).then(function (response) {
        _this2.$message.success('序号更新成功');
      }).catch(function (error) {
        _this2.$message.error('序号更新失败');
      });
    },
    changePostRecommend: function changePostRecommend(row) {
      var _this3 = this;
      // 更新发帖推荐状态
      var formData = {
        id: row.id,
        isTj: row.isTj
      };
      (0, _topicManagement.updateTopic)(formData).then(function (response) {
        _this3.$message.success("".concat(row.isTj ? '开启' : '关闭', "\u53D1\u5E16\u63A8\u8350\u6210\u529F"));
      }).catch(function (error) {
        _this3.$message.error('更新发帖推荐状态失败');
      });
    },
    changeHotRecommend: function changeHotRecommend(row) {
      var _this4 = this;
      // 更新热门推荐状态
      var formData = {
        id: row.id,
        isHot: row.isHot
      };
      (0, _topicManagement.updateTopic)(formData).then(function (response) {
        _this4.$message.success("".concat(row.isHot ? '开启' : '关闭', "\u70ED\u95E8\u63A8\u8350\u6210\u529F"));
      }).catch(function (error) {
        _this4.$message.error('更新热门推荐状态失败');
      });
    },
    fetchData: function fetchData() {
      var _this5 = this;
      this.tableLoading = true;
      var params = _objectSpread({
        page: this.currentPage,
        limit: this.pageSize
      }, this.searchForm);
      (0, _topicManagement.getTopicList)(params).then(function (response) {
        _this5.tableData = response.records;
        _this5.total = response.total;
        _this5.tableLoading = false;
      }).catch(function (error) {
        _this5.tableLoading = false;
        _this5.$message.error('获取数据失败');
      });
    },
    getDetail: function getDetail(id) {
      var _this6 = this;
      (0, _topicManagement.getTopicInfo)(id).then(function (response) {
        _this6.editForm = _objectSpread({}, response.data);
        _this6.dialogVisible = true;
      }).catch(function (error) {
        _this6.$message.error('获取详情失败');
      });
    },
    handleDialogClose: function handleDialogClose() {
      this.$refs.editForm && this.$refs.editForm.resetFields();
      this.editForm = {
        id: '',
        title: '',
        num: 0,
        peopleNum: 0,
        ordno: 0,
        isTj: 0,
        isHot: 0
      };
    },
    submitForm: function submitForm() {
      var _this7 = this;
      this.$refs.editForm.validate(function (valid) {
        if (valid) {
          var formData = _objectSpread({}, _this7.editForm);
          if (_this7.isEdit) {
            // 编辑
            (0, _topicManagement.updateTopic)(formData).then(function (response) {
              _this7.$message.success('编辑成功');
              _this7.dialogVisible = false;
              _this7.fetchData();
            }).catch(function (error) {
              _this7.$message.error('编辑失败');
            });
          } else {
            // 新增
            (0, _topicManagement.addTopic)(formData).then(function (response) {
              _this7.$message.success('新增成功');
              _this7.dialogVisible = false;
              _this7.fetchData();
            }).catch(function (error) {
              _this7.$message.error('新增失败');
            });
          }
        }
      });
    },
    // 格式化时间
    formatTime: function formatTime(time) {
      if (!time) return '';
      return (0, _index.parseTime)(time, '{y}-{m}-{d} {h}:{i}:{s}');
    }
  }
};